import React, { useEffect, useState } from "react";
import "./PainelWhatsApp.css";

const PainelWhatsApp = () => {
  const [status, setStatus] = useState(null); // status_conexao
  const [statusPagamento, setStatusPagamento] = useState(null);
  const [qr, setQr] = useState(null);
  const [hora, setHora] = useState(null);
  const [mensagem, setMensagem] = useState("");
  const [isDesconectando, setIsDesconectando] = useState(false);

  const carregarStatus = async () => {
    try {
      const res = await fetch("/crm-wly/api/whatsapp/painel_whatsapp.php", {
        credentials: "include",
      });
      const data = await res.json();

      setStatus(data.status_conexao);
      setStatusPagamento(data.status_pagamento);
      setQr(data.qr || null);
      setMensagem(data.mensagem || "");
      setHora(new Date().toLocaleTimeString());
    } catch (err) {
      console.error("Erro ao carregar status do WhatsApp", err);
    }
  };

  const desconectar = async () => {
    const confirmar = window.confirm("Tem certeza que deseja desconectar o WhatsApp?");
    if (!confirmar) return;

    setIsDesconectando(true); // entra no estágio "Desconectando..."

    try {
      const res = await fetch("/crm-wly/api/whatsapp/desconectar.php", {
        method: "POST",
        credentials: "include",
      });
      const data = await res.json();
      if (data.success) {
        alert("WhatsApp desconectado com sucesso.");
        carregarStatus();
      } else {
        alert(data.message || "Erro ao desconectar.");
      }
    } catch (err) {
      alert("Erro ao desconectar.");
    } finally {
      setIsDesconectando(false); // volta ao normal
    }
  };

  useEffect(() => {
    carregarStatus();
    const interval = setInterval(carregarStatus, 10000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="painel-h2">
      <h1 style={{ borderBottom: "none" }}>Painel de Integração WhatsApp</h1>

      <div className="painel-wzp">
        {status === "ativo" && statusPagamento === "pago" ? (
          <>
            <p>{mensagem || "WhatsApp conectado com sucesso!"}</p>
            <button
              className="btn-desconectar"
              onClick={desconectar}
              disabled={isDesconectando}
              style={{
                marginTop: 20,
                padding: "10px 20px",
                backgroundColor: isDesconectando ? "#aaa" : "#dc3545",
                color: "white",
                border: "none",
                borderRadius: "6px",
                cursor: isDesconectando ? "not-allowed" : "pointer",
              }}
            >
              {isDesconectando ? "Desconectando..." : "Desconectar WhatsApp"}
            </button>
          </>
        ) : qr ? (
          <>
            <p style={{ marginTop: 20 }}>Escaneie o QR Code abaixo para conectar:</p>
            <img src={qr} alt="QR Code" />
            <p className="hora-atualizacao">Atualizado às: {hora}</p>
          </>
        ) : (
          <p>Carregando QR Code...</p>
        )}
      </div>
    </div>
  );
};

export default PainelWhatsApp;
